export default function headerSearchHandler() {
    const mainNav = document.querySelector('.main-nav__wrapper');
    const search = document.querySelector('.a-main-nav');
    let searchBtn;
    let field;
    let clear;

    if (search) {
        searchBtn = search.querySelector('.a-main-nav__search-btn');
        field = search.querySelector('.a-main-nav__search');
        clear = search.querySelector('.a-main-nav__clear');
    }

    function clearField() {
        field.value = '';
    }

    function showSearchField() {
        event.preventDefault(); // eslint-disable-line
        search.classList.add('active');
        mainNav.style.paddingRight = '62px';
        search.style.position = 'absolute';
        field.focus();
        const close = search.querySelector('.a-main-nav__close');
        close.addEventListener('click', () => closeSearch(), { once: true }); // eslint-disable-line
    }

    function closeSearch() {
        search.classList.remove('active');
        setTimeout(() => {
            mainNav.style.paddingRight = '0';
            search.style.position = 'relative';
        }, 300);

        clearField();
        searchBtn.addEventListener('click', () => showSearchField(), { once: true });
    }

    function showClear() {
        if (event.target.value.length !== 0) { // eslint-disable-line
            clear.style.display = 'block';
        } else {
            clear.style.display = 'none';
        }
    }
    if (searchBtn && field && clear) {
        searchBtn.addEventListener('click', () => showSearchField(), { once: true });
        field.addEventListener('input', showClear);
        clear.addEventListener('click', () => {
            clearField();
            field.focus();
        });
    }
}
